import Vue from 'vue'
import Router from 'vue-router'
import {routes} from './config'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import _ from 'lodash'
import { ensureCompanyContext } from './guards'

// Hack to fix unnecessary exceptions with router navigation. See: https://github.com/vuejs/vue-router/issues/2881#issuecomment-520554378

const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch((err) => {
    if (Router.isNavigationFailure(err)) {
      // resolve err
      return err
    }
    // rethrow error
    return Promise.reject(err)
  })
}

Vue.use(Router)
const router = new Router({
  mode: 'hash',
  linkActiveClass: 'active',
  routes: routes(),
  scrollBehavior(to) {
    // Support deep-linking to anchors with smooth scroll
    if (to && to.hash) {
      // Wait for the next paint so target exists after route mount
      setTimeout(() => {
        const target = document.querySelector(to.hash)
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' })
        } else {
          document.getElementById('app')?.scrollIntoView({ behavior: 'smooth' })
        }
      }, 0)
      return
    }
    document.getElementById('app').scrollIntoView({behavior: 'smooth'})
  },
})

router.beforeEach(async (to, from, next) => {
  const isMobile = window.innerWidth < 960;
  if (to.path === '/' && isMobile) {
    next({ path: '/trade' }); // Using object form for consistency, though string is fine.
    return;
  }

  await ensureCompanyContext();

  const guards = _.get(to, 'meta.guards', []);
  if (guards && Array.isArray(guards) && guards.length > 0) {
    for (const guard of guards) {
      // Assuming guard functions are of the form:
      // (to, from, routerNext) => "path_to_redirect_to" | null | undefined
      // Where `routerNext` is the `next` function from `beforeEach`.
      // The guard is expected to return a redirect location or null/undefined to proceed.
      const redirectLocation = guard(to, from, next);

      if (redirectLocation != null) { 
        next(redirectLocation); 
        return; // IMPORTANT: Exit beforeEach immediately after a guard initiates a redirect.
      }
      // If redirectLocation is null/undefined, this guard allows navigation to continue to the next guard or the route itself.
    }
  }
  
  
  next()
})

router.afterEach(() => {
  // NProgress.done()
})

export default router
